import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {FireInTheHole2} from "../../FireInTheHole2";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";
import {FITH2Model, IWildMiningGroup} from "../../server/FITH2Model";
import {FITH2Symbol} from "../../symbols/FITH2Symbol";
import {FITH2GameConfig} from "../../configs/FITH2GameConfig";


export class WildMiningPresentation implements SimplePresentation {
    name: string = "WildMiningPresentation";

    shouldRun(): boolean {
        return FireInTheHole2.model.gameData.wildMiningTriggered;
    }

    start(controller: SimplePresentationRunnerController): void {
        const model: FITH2Model = FireInTheHole2.model;
        if (NolimitConfig.isDevMode) {
            if (model.linkedBombPositions.length < 1) {
                debugger;
            }
        }
        const tl = gsap.timeline(),
            fast: boolean = (FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN) || FireInTheHole2.model.hasNoAvalancheWin),
            linkedBombPositions: number[][] = model.linkedBombPositions,
            symbolShakeDuration: number = 0.67;
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(1.5);
        }));

        tl.add(FireInTheHole2.symbolAnimation.addDimmer(), 0);
        const introDelay: number = tl.duration() * 0.3;
        tl.add(FireInTheHole2.wildMining.onWildMining(), introDelay);
        model.linkedBombGroups.forEach((group: IWildMiningGroup) => {
            const toPosition: number[] = group.symbols[1],
                toMoveSymbolsNum: number = group.symbols.length;

            [group.symbols[0], group.symbols[toMoveSymbolsNum - 1]].forEach((pos: number[]) => {
                const symbol: FITH2Symbol = FireInTheHole2.reelArea.getSymbol(pos);
                if (!symbol.isRemoved && !symbol.isWild) {
                    const symPos: PIXI.Point = symbol.position,
                        fromX: number = symPos.x,
                        fromY: number = symPos.y,
                        distanceX: number = (toPosition[0] === symbol.reelId ? 0 : 1) * (toPosition[0] > symbol.reelId ? 1 : -1) * FITH2GameConfig.symbolWidth,
                        distanceY: number = (toPosition[1] === symbol.id ? 0 : 1) * (toPosition[1] > symbol.id ? 1 : -1) * FITH2GameConfig.symbolHeight;
                    tl.add([
                        () => {
                            symbol.parent.removeChild(symbol);
                            FireInTheHole2.reelArea.allReels[pos[0]].reelView.initialWinSymbolView.addChild(symbol);
                        },
                        symbol.addScreenLayer(symbolShakeDuration),
                        symbol.getShakeAnimation({duration: symbolShakeDuration, x: 6, y: 0})
                    ], introDelay);
                    tl.add([
                        () => symbol.afterWildMining(),
                        gsap.to(symbol, 0.17, {x: fromX + distanceX, y: fromY + distanceY}),
                        gsap.to(symbol, 0, {alpha: 0, delay: 0.17})
                    ], introDelay + symbolShakeDuration);
                }
            });
        });
        linkedBombPositions.forEach((pos: number[]) => {
            const symbol: FITH2Symbol = FireInTheHole2.reelArea.getSymbol(pos);
            tl.add([
                () => {
                    symbol.parent.removeChild(symbol);
                    FireInTheHole2.reelArea.allReels[pos[0]].reelView.fullWildSymbolWinView.addChild(symbol);
                },
                symbol.addScreenLayer(symbolShakeDuration),
                symbol.getShakeAnimation({duration: symbolShakeDuration, x: 3, y: 0})
            ], introDelay + 0.001);
            tl.add(FireInTheHole2.reelArea.allReels[pos[0]].reelView.turnWild(pos[1]), introDelay + symbolShakeDuration + 0.17);
        });
        tl.add(FireInTheHole2.symbolAnimation.removeDimmer(), introDelay + 0.6);
        model.gameData.removedSymbols.forEach((reel: string[], i: number) => {
            reel.forEach((sym: string, j: number) => {
                if (sym != model.gameData.reels[i][j]) {
                    tl.add(FireInTheHole2.reelArea.getSymbol([i, j]).explode("small"), introDelay + symbolShakeDuration + 0.17 + 10 * 0.033);
                }
            });
        });
        tl.add(() => {
            FireInTheHole2.gameViewContainer.onBombExplode();
        }, introDelay + 0.8);
        tl.add(FireInTheHole2.reelTopBar.updateBars(), "-=0.3");
        tl.add(() => {FireInTheHole2.reelArea.updateNewSymbolBehindBar();});
        tl.to(this, {duration: 0.01});
        tl.add(() => {
            controller.finish();
        });
    }
}